module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "DogeLogo.58faeab6.svg";